import React from 'react'
import PropTypes from 'prop-types'
import { withRouteData, Link } from 'react-static'
import Title from '../../components/Title'
import Transitionable from '../Transitionable'
import styles from '../Blog/styles.module.css'
import Sidebar from '../../components/Sidebar'
import BlogPost from '../../components/BlogPost'

import './highlight.css'

class Post extends Transitionable {

  robotState = 'blog'

  renderTransitioned() {
    return withRouteData((post) => ( 
      <section className={styles.blog}>
        <Title page={post.title} />
        <Sidebar />
        <BlogPost post={post} />
      </section>
    ))()
  }

}

export default Post


// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Post/index.js